<template lang="pug">
.stats-box(v-bind:class="{ 'flipped': showBack }")
   .front
      .flex.justify-between.items-center.mx-4
         a(href="javascript(void)" @click.prevent="showBack=!showBack")
            img.h-6(:src="pageDetail.favicon" width="25")

         h3 {{pageDetail.name}}
         i.svg-white.cursor-pointer(@click="showBack=!showBack")
            svg(xmlns='http://www.w3.org/2000/svg', width='24', height='24', viewbox='0 0 24 24')
               path(d="M12 8c-2.2 0-4 1.8-4 4s1.8 4 4 4c2.2 0 4-1.8 4-4s-1.8-4-4-4zM12 14c-1.1 0-2-0.9-2-2s0.9-2 2-2c1.1 0 2 0.9 2 2s-0.9 2-2 2z")
               path(d="M20.3 15.4c0.1-0.2 0.3-0.4 0.7-0.4 1.7 0 3-1.3 3-3s-1.3-3-3-3h-0.2c-0.2 0-0.4-0.1-0.5-0.3 0-0.1 0-0.1-0.1-0.2-0.1-0.2-0.1-0.5 0.2-0.8 1.2-1.2 1.2-3.1 0-4.2v0c0 0 0 0 0 0-0.6-0.6-1.3-0.9-2.1-0.9 0 0 0 0 0 0-0.8 0-1.6 0.3-2.2 0.9-0.2 0.2-0.5 0.2-0.7 0.1-0.2 0-0.4-0.3-0.4-0.6 0-1.7-1.3-3-3-3s-3 1.3-3 3v0.2c0 0.2-0.1 0.4-0.3 0.5-0.1 0-0.1 0-0.2 0.1-0.2 0.1-0.5 0-0.8-0.2-1.2-1.2-3.1-1.2-4.2 0-1.2 1.2-1.2 3.1 0.1 4.3 0.2 0.2 0.2 0.5 0.1 0.8-0.1 0.2-0.4 0.4-0.7 0.4-1.7 0-3 1.3-3 3s1.3 3 3 3h0.2c0.3 0 0.5 0.2 0.6 0.4s0.1 0.5-0.2 0.8c-0.6 0.6-0.9 1.3-0.9 2.1s0.3 1.5 0.9 2.1c0 0 0 0 0 0 1.2 1.2 3.1 1.2 4.3-0.1 0.2-0.2 0.5-0.2 0.8-0.1s0.4 0.3 0.4 0.7c0 1.7 1.3 3 3 3s3-1.3 3-3v-0.2c0-0.3 0.2-0.5 0.4-0.6s0.5-0.1 0.8 0.2c1.2 1.2 3.1 1.2 4.2 0 1.2-1.2 1.2-3.1-0.1-4.3-0.1-0.2-0.2-0.5-0.1-0.7 0 0 0 0 0 0zM18.5 14.6c-0.4 1-0.2 2.1 0.6 3 0.2 0.2 0.3 0.4 0.3 0.7s-0.1 0.5-0.3 0.7c-0.2 0.2-0.4 0.3-0.7 0.3 0 0 0 0 0 0-0.3 0-0.5-0.1-0.8-0.4-0.8-0.8-1.9-1-2.9-0.5-1 0.4-1.6 1.4-1.6 2.4v0.2c0 0.6-0.4 1-1 1s-1-0.4-1-1c0 0 0-0.1 0-0.1 0-1.1-0.7-2-1.7-2.4-0.3-0.2-0.7-0.2-1.1-0.2-0.7 0-1.4 0.3-1.9 0.8-0.4 0.4-1 0.4-1.4 0 0 0 0 0 0 0v0c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5 0.4-0.8c0.8-0.8 1-1.9 0.5-2.9-0.4-1-1.4-1.6-2.4-1.6h-0.2c-0.6 0-1-0.4-1-1s0.4-1 1-1c0 0 0.1 0 0.1 0 1.1 0 2-0.7 2.4-1.7s0.2-2.1-0.6-3c-0.4-0.4-0.4-1 0-1.4s1-0.4 1.5 0.1c0.7 0.7 1.8 0.9 2.7 0.6 0.1 0 0.2 0 0.3-0.1 1-0.4 1.6-1.4 1.6-2.4v-0.2c0-0.6 0.4-1 1-1s1 0.4 1 1.1c0 1.1 0.6 2 1.6 2.4s2.1 0.2 3-0.6c0.2-0.2 0.4-0.3 0.7-0.3v0c0.3 0 0.5 0.1 0.7 0.3 0 0 0 0 0 0 0.4 0.4 0.4 1-0.1 1.5-0.7 0.7-0.9 1.8-0.6 2.7 0 0.1 0 0.2 0.1 0.3 0.4 1 1.4 1.6 2.4 1.6h0.2c0.6 0 1 0.4 1 1s-0.4 1-1.1 1c-1 0-2 0.6-2.4 1.6z")

      .text-6xl.mt-8 {{pageData[pageDetail.settings.bigNumber] || realtimeStat}}
      .text-xs.uppercase {{dropdownOptions.names[pageDetail.settings.bigNumber]}}
      line-chart.line-chart.pt-8(:dataset="graphData")
      .flex.mt-8
         .flex-1
            .text-3xl {{pageData[pageDetail.settings.topLeft]}}
            .text-xs.uppercase {{dropdownOptions.names[pageDetail.settings.topLeft]}}
         .flex-1
            .text-3xl {{pageData[pageDetail.settings.topRight]}}
            .text-xs.uppercase {{dropdownOptions.names[pageDetail.settings.topRight]}}
      .flex.mt-8
         .flex-1
            .text-3xl {{pageData[pageDetail.settings.bottomLeft]}}
            .text-xs.uppercase {{dropdownOptions.names[pageDetail.settings.bottomLeft]}}
         .flex-1
            .text-3xl {{pageData[pageDetail.settings.bottomRight]}}
            .text-xs.uppercase {{dropdownOptions.names[pageDetail.settings.bottomRight]}}
   .back
      .box-header
         .flex.justify-between.items-center.mx-4
            i.svg-white.cursor-pointer(@click="showBack=!showBack")
               svg(xmlns='http://www.w3.org/2000/svg', width='24', height='24', viewbox='0 0 24 24')
                  path(d="M21.7 7.3l-5-5c-0.2-0.2-0.4-0.3-0.7-0.3h-11c-1.7 0-3 1.3-3 3v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-11c0-0.3-0.1-0.5-0.3-0.7zM16 20h-8v-6h8v6zM20 19c0 0.6-0.4 1-1 1h-1v-7c0-0.6-0.4-1-1-1h-10c-0.6 0-1 0.4-1 1v7h-1c-0.6 0-1-0.4-1-1v-14c0-0.6 0.4-1 1-1h1v4c0 0.6 0.4 1 1 1h8c0.6 0 1-0.4 1-1s-0.4-1-1-1h-7v-3h7.6l4.4 4.4v10.6z")
            h3 {{pageDetail.name}}
            i.svg-white.cursor-pointer(@click="showBack=!showBack")
               svg(xmlns='http://www.w3.org/2000/svg', width='24', height='24', viewbox='0 0 24 24')
                  path(d="M13.4 12l5.3-5.3c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0l-5.3 5.3-5.3-5.3c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l5.3 5.3-5.3 5.3c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3l5.3-5.3 5.3 5.3c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-5.3-5.3z")
      .box-body
         .mt-4
            label.settings-input-label name
            input.settings-input(v-model='pageDetail.name', placeholder='Name')
         .mt-4
            label.settings-input-label favicon url
            input.settings-input(v-model='pageDetail.favicon', placeholder='Favicon')
         .mt-4
            dropdown(v-model='pageDetail.settings.timeframe', label='timeframe', :options='dropdownOptions.timeframe')
         .flex.mt-4
            .flex-1.mr-4
               dropdown(v-model='pageDetail.settings.bigNumber', label='big number', :options='dropdownOptions.bigNumber')
            .flex-1
               dropdown(v-model='pageDetail.settings.graph', label='graph', :options='dropdownOptions.graph')
         .flex.mt-4
            .flex-1.mr-4
               dropdown(v-model='pageDetail.settings.topLeft', label='top left', :options='dropdownOptions.others')
            .flex-1
               dropdown(v-model='pageDetail.settings.topRight', label='top right', :options='dropdownOptions.others')
         .flex.mt-4
            .flex-1.mr-4
               dropdown(v-model='pageDetail.settings.bottomLeft', label='bottom left', :options='dropdownOptions.others')
            .flex-1
               dropdown(v-model='pageDetail.settings.bottomRight', label='bottom right', :options='dropdownOptions.others')
         .flex.justify-center.mt-2
            button.btn-gootics.mr-4(@click='showBack=!showBack', class='hover:bg-blue-dark') Save
            button.btn-secondary.mr-0(@click='showBack=!showBack', class='hover:bg-red-dark') Delete
</template>

<script>
import LineChart from '@/components/modules/LineChart'
import Dropdown from './Dropdown'
import DropdownOptions from './dropdown-options'

export default {
  name: 'SideBox',
  components: {
    LineChart,
    Dropdown
  },
  props: {
    page: Object
  },
  created () {
    this.pageDetail = this.page || {}
    this.pageDetail.settings = this.pageDetail.settings || {}
    this.realtimeStat = this.page.data.realtime
    this.pageData = this.page.data.totals
    this.graphData = this.page.data.graph
  },
  methods: {

  },
  data () {
    return {
      showBack: false,
      showMenu: true,
      spinner: true,
      pageDetail: {
        settings: {}
      },
      pageData: {},
      graphData: {},
      realtimeStat: '0',
      dropdownOptions: DropdownOptions
    }
  }
}
</script>

<style scoped>

.line-chart {
   height: 210px;
   width: 90%;
   margin: 0 auto
}

.menu {
   position: absolute;
   top: 4.3rem;
   left: 1.2rem;
   padding: 1rem;
   z-index: 999;
}

.menu a {
   text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/modules/SiteBoxDemo.vue